/*
  Cofre de credenciais do navegador.

  Guarda usuário e senha de forma CRIPTOGRAFADA (AES-GCM via Web Crypto)
  no localStorage, para o recurso "salvar senha" da tela de login.

  Observação de segurança: a chave é derivada de um segredo embutido no
  app, portanto isto é uma proteção de OFUSCAÇÃO forte (dificulta a leitura),
  não um sigilo absoluto — a responsabilidade final é do usuário do
  dispositivo, conforme o padrão adotado nos projetos.
*/

const SEGREDO = "IntegraReceitas::cofre::v1";
const SALT = new TextEncoder().encode("ir-static-salt-2026");
const CHAVE_STORAGE = "ir_credenciais";

async function derivarChave() {
  const material = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(SEGREDO),
    "PBKDF2",
    false,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: SALT, iterations: 100000, hash: "SHA-256" },
    material,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

function paraBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

function deBase64(texto) {
  return Uint8Array.from(atob(texto), (c) => c.charCodeAt(0));
}

/* Salva (criptografado) usuário e senha */
export async function salvarCredenciais(email, senha) {
  try {
    const chave = await derivarChave();
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const dados = new TextEncoder().encode(JSON.stringify({ email, senha }));
    const cifrado = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      chave,
      dados
    );
    localStorage.setItem(
      CHAVE_STORAGE,
      JSON.stringify({ iv: paraBase64(iv), dado: paraBase64(cifrado) })
    );
  } catch (e) {
    /* silencioso: se a criptografia falhar, apenas não salva */
  }
}

/* Lê e descriptografa. Retorna { email, senha } ou null */
export async function lerCredenciais() {
  try {
    const bruto = localStorage.getItem(CHAVE_STORAGE);
    if (!bruto) return null;
    const { iv, dado } = JSON.parse(bruto);
    const chave = await derivarChave();
    const claro = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: deBase64(iv) },
      chave,
      deBase64(dado)
    );
    return JSON.parse(new TextDecoder().decode(claro));
  } catch (e) {
    return null;
  }
}

/* Remove as credenciais salvas */
export function limparCredenciais() {
  localStorage.removeItem(CHAVE_STORAGE);
}

export function temCredenciais() {
  return !!localStorage.getItem(CHAVE_STORAGE);
}
